
import { Component, mixins } from 'nuxt-property-decorator';
import PageBreadcrumbs from '~/components/UI/Breadcrumbs.vue';
import BaseLayoutMixin from '../../node_modules/sitis-nuxt/lib/cms/BaseLayoutMixin';

@Component({
    components: { PageBreadcrumbs },
})
export default class MainLayout extends mixins(BaseLayoutMixin) {}
